const autofillBg = '#21232D';

const autofillInputSx = {
  '& .MuiInputBase-input:-webkit-autofill': {
    WebkitBoxShadow: `0 0 0 1000px ${autofillBg} inset`,
    WebkitTextFillColor: '#fff',
    caretColor: '#fff',
    transition: 'background-color 5000s ease-in-out 0s',
  },
  '& .MuiInputBase-input:-webkit-autofill:hover': {
    WebkitBoxShadow: `0 0 0 1000px ${autofillBg} inset`,
    WebkitTextFillColor: '#fff',
  },
  '& .MuiInputBase-input:-webkit-autofill:focus': {
    WebkitBoxShadow: `0 0 0 1000px ${autofillBg} inset`,
    WebkitTextFillColor: '#fff',
  },
  '& .MuiInputBase-input::selection': {
    backgroundColor: 'rgba(149, 242, 5, 0.35)',
    color: '#fff',
  },
};

export const darkFieldSx = {
  ...autofillInputSx,
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    bgcolor: autofillBg,
    borderRadius: 1.5,
    '& fieldset': { borderColor: 'rgba(255,255,255,0.35)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.55)' },
    '&.Mui-focused fieldset': { borderColor: '#95F205', borderWidth: 2 },
    '&.Mui-error fieldset': { borderColor: '#f87171' },
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.65)' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#95F205' },
  '& .MuiInputBase-input::placeholder': { color: 'rgba(255,255,255,0.5)', opacity: 1 },
  '& .MuiFormHelperText-root': { color: '#f87171' },
  '& .MuiSelect-select': { color: '#fff' },
  '& .MuiSvgIcon-root': { color: 'rgba(255,255,255,0.7)' },
  '& .MuiIconButton-root': { color: 'rgba(255,255,255,0.7)' },
};

export const otpDigitFieldSx = {
  ...autofillInputSx,
  flex: 1,
  maxWidth: 52,
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    bgcolor: autofillBg,
    borderRadius: 1.5,
    '& fieldset': { borderColor: 'rgba(255,255,255,0.35)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.55)' },
    '&.Mui-focused fieldset': { borderColor: '#95F205', borderWidth: 2 },
    '&.Mui-error fieldset': { borderColor: '#f87171' },
  },
  '& .MuiInputBase-input': {
    py: 1.5,
    px: 0,
    fontSize: 20,
    fontWeight: 700,
    textAlign: 'center',
    color: '#fff',
  },
  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '& input[type=number]': { MozAppearance: 'textfield' },
};

/** Native numeric keypad on iOS/Android — use type="tel" on the TextField. */
export const getOtpDigitInputProps = (index = 0) => ({
  inputMode: 'numeric',
  pattern: '[0-9]*',
  maxLength: 1,
  autoComplete: index === 0 ? 'one-time-code' : 'off',
  enterKeyHint: index === 5 ? 'done' : 'next',
  style: { fontWeight: 700, textAlign: 'center', color: '#fff', fontSize: 20 },
});

export const OTP_AUTOFILL_INPUT_PROPS = {
  type: 'tel',
  inputMode: 'numeric',
  pattern: '[0-9]*',
  autoComplete: 'one-time-code',
};

/** Focus first OTP cell and retry — iOS often ignores a single programmatic focus after route change. */
export const focusOtpField = (inputEl) => {
  if (!inputEl?.focus) return;
  try {
    inputEl.focus({ preventScroll: true });
  } catch {
    inputEl.focus();
  }
  if ('readOnly' in inputEl) {
    inputEl.readOnly = true;
    inputEl.focus();
    requestAnimationFrame(() => {
      inputEl.readOnly = false;
      inputEl.focus();
    });
  }
};

export const scheduleOtpAutofocus = (getInput) => {
  const attempt = () => focusOtpField(typeof getInput === 'function' ? getInput() : getInput);
  attempt();
  const timerIds = [50, 150, 400, 800].map((ms) => window.setTimeout(attempt, ms));
  return () => timerIds.forEach((id) => window.clearTimeout(id));
};

export const authPrimaryButtonSx = {
  height: 48,
  minHeight: 48,
  borderRadius: '999px',
  fontWeight: 700,
  fontSize: 14,
  letterSpacing: 1,
  textTransform: 'uppercase',
  bgcolor: '#95F205',
  color: '#000',
  boxShadow: '0 2px 10px rgba(149, 242, 5, 0.4)',
  '&:hover': {
    bgcolor: '#a8ff0a',
    boxShadow: '0 2px 10px rgba(149, 242, 5, 0.4)',
  },
  '&.Mui-disabled': {
    bgcolor: 'rgba(149, 242, 5, 0.35)',
    color: 'rgba(0, 0, 0, 0.45)',
  },
};
